import { render, staticRenderFns } from "./r-firefly-dialog.vue?vue&type=template&id=19b2c8c0&scoped=true"
import script from "./r-firefly-dialog.vue?vue&type=script&lang=js"
export * from "./r-firefly-dialog.vue?vue&type=script&lang=js"
import style0 from "./r-firefly-dialog.vue?vue&type=style&index=0&id=19b2c8c0&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b2c8c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19b2c8c0')) {
      api.createRecord('19b2c8c0', component.options)
    } else {
      api.reload('19b2c8c0', component.options)
    }
    module.hot.accept("./r-firefly-dialog.vue?vue&type=template&id=19b2c8c0&scoped=true", function () {
      api.rerender('19b2c8c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/firefly/r-firefly-dialog.vue"
export default component.exports